import React from "react";
import PropTypes from "prop-types";

const ALL_CANDIDATES = ["prophet", "autoarima", "ses", "tidemodel", "arima", "holts"];

// CandidateChips renders a toggle chip per candidate algorithm.
// Selected chips are filled; unselected are outlined. At least one must
// remain selected at all times.
export default function CandidateChips({ candidates, onChange }) {
  function toggle(name) {
    const isSelected = candidates.includes(name);
    // Don't allow emptying the set
    if (isSelected && candidates.length === 1) return;
    const next = isSelected
      ? candidates.filter((c) => c !== name)
      : [...candidates, name];
    onChange(next);
  }

  return (
    <div className="flex flex-wrap items-center gap-2 px-4 pb-3">
      <span className="mr-1 text-xs font-medium uppercase tracking-wide text-text-3">Algorithms</span>
      {ALL_CANDIDATES.map((name) => {
        const selected = candidates.includes(name);
        return (
          <button
            key={name}
            type="button"
            onClick={() => toggle(name)}
            aria-pressed={selected}
            className={`inline-flex items-center rounded-ctrl px-2.5 py-1 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-primary ${
              selected
                ? "bg-primary text-white"
                : "border border-card-bd bg-card text-text-2 hover:border-primary hover:text-primary"
            }`}
          >
            {name}
          </button>
        );
      })}
      <span
        className="cursor-help text-xs leading-none text-text-3"
        data-tooltip-id="instantTooltip"
        data-tooltip-content="Picked candidates compete each run. Nightly auto-reselect is managed in Application Parameters."
        aria-label="Nightly auto-reselect is managed in Application Parameters"
      >
        ⓘ
      </span>
    </div>
  );
}

CandidateChips.propTypes = {
  candidates: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};
